export default __webpack_public_path__ + "static/media/matheadphone.674f65a2.png";